import { useTranslation } from "react-i18next";
import BasicDialog from "../../../common/components/functional/dialogs/BasicDialog";
import { useAppDispatch } from "../../../app/hooks";
import OverlaySpinner from "../../../common/components/functional/overlaySpinner/OverlaySpinner";
import { Box, Typography } from "@mui/material";
import { CustomButton } from "../../../common/components/functional/customButton/CustomButton";
import CloseIcon from "@mui/icons-material/Close";
import useIsLoading from "../../../hooks/useIsLoading";
import { useEffect, useState } from "react";
import { fetchApplicantCoverLetter } from "../../jobAds/jodAdApplicants/jobAdApplicantsSlice";
import { isFulfilled } from "@reduxjs/toolkit";

type Props = {
  closeDialog: () => void;
  status: {
    open: boolean;
    talentId: string;
    jobAdId: string;
    talentFullName?: string;
  };
};

export const AssignmentCoverLetter = ({
  status: { open: isOpen, talentId, jobAdId, talentFullName },
  closeDialog,
}: Props) => {
  const dispatch = useAppDispatch();
  const { t } = useTranslation();

  const [selectedCoverLetter, setSelectedCoverLetter] = useState<string | null>(
    null,
  );
  const isCoverLetterLoading = useIsLoading(["jobAdApplicants"]);

  useEffect(() => {
    if (!isOpen || !talentId || !jobAdId) return;
    dispatch(fetchApplicantCoverLetter({ jobAdId, talentId })).then(
      (action) => {
        if (isFulfilled(action)) {
          setSelectedCoverLetter(
            action.payload.coverLetter || t("talentProfile:noCoverLetter"),
          );
        } else {
          setSelectedCoverLetter(
            t("talentProfile:talentCoverLetterFetchError"),
          );
        }
      },
    );
  }, [isOpen, jobAdId, talentId, dispatch, t]);

  const title = `${t("order:coverLetter")}${talentFullName ? ` - ${talentFullName}` : ""}`;

  return (
    <BasicDialog
      open={isOpen}
      onCancel={closeDialog}
      title={title}
      PaperProps={{ sx: { minWidth: "550px" } }}
      noBorder
      hideActions
      content={
        <>
          {isCoverLetterLoading ? (
            <Box m={4}>
              <OverlaySpinner isLoading={isCoverLetterLoading} />
            </Box>
          ) : (
            <Box>
              <Typography>{selectedCoverLetter}</Typography>
              <CustomButton
                variant="outlined"
                sx={{ borderRadius: "24px", mt: 2 }}
                onClick={closeDialog}
              >
                <CloseIcon sx={{ fontSize: "1.25rem" }} />
                {t("common:close")}
              </CustomButton>
            </Box>
          )}
        </>
      }
    />
  );
};
